export const GTM_TRACKING_ID = process.env.NEXT_PUBLIC_GTM_TRACKING_ID!
